import HttpService from "./HttpService";

export default {
    find(tarjeta) {
        // const urlDESOp1 = "http://209.97.181.190:9091/bus/tarjeta/buscarTarjeta";
        // const urlDESOp2 = "http://209.97.181.190:9091/bus/tarjeta/appTarjetas";
        const urlPRO = 'https://recursos.kbus.kradac.com/bus/tarjeta/buscarTarjeta';
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                tarjeta,
                criterio: tarjeta,
                tipoCriterio: 1
            }).then((response) => {
                if (response.data.en === 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    },

    findModal(nrotarjeta) {
        //const urlDESOp1 = "http://209.97.181.190:9091/bus/tarjeta/buscarMovimientoTarjeta";
        const urlPRO = 'https://recursos.kbus.kradac.com/bus/tarjeta/buscarMovimientoTarjeta';
        return new Promise((resolve, reject) => {
            HttpService.post(urlPRO, {
                tarjeta: nrotarjeta,
                limit: 10,
            }).then((response) => {
                if (response.data.en === 1) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            }).catch((error) => reject(error));
        })
    }
}
